import { render, staticRenderFns } from "./menusetting.vue?vue&type=template&id=d270512c&scoped=true&"
import script from "./menusetting.vue?vue&type=script&lang=js&"
export * from "./menusetting.vue?vue&type=script&lang=js&"
import style0 from "./menusetting.vue?vue&type=style&index=0&id=d270512c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d270512c",
  null
  
)

export default component.exports